import { toast } from "@/shared/hooks/use-toast";

/**
 * 复制到剪贴板 + toast。`navigator.clipboard` 只在安全上下文(https / localhost)存在,
 * 内网 http 打开时是 undefined —— 先判再调,别让一个 TypeError 变成「点了没反应」。
 */
export async function copyText(text: string, what: string): Promise<void> {
  const clip = typeof navigator !== "undefined" ? navigator.clipboard : undefined;
  if (!clip?.writeText) {
    toast({ title: "浏览器不允许复制,请手动选中复制", description: text, variant: "destructive" });
    return;
  }
  try {
    await clip.writeText(text);
    toast({ title: `${what}已复制`, description: text });
  } catch {
    toast({ title: "复制失败,请手动选中复制", description: text, variant: "destructive" });
  }
}
